// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useEffect } from "react";
import { connect } from "react-redux";

interface OwnProps {
    type: "Product" | "Generic";
}

const mapStateToProps = (state: ApplicationState) => ({
    priceSpiderProductKey: state.context.settings.settingsCollection.bunzlSettings?.priceSpiderProductKey,
    priceSpiderGenericKey: state.context.settings.settingsCollection.bunzlSettings?.priceSpiderGenericKey,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PriceSpider = ({ type, priceSpiderProductKey, priceSpiderGenericKey }: Props) => {
    useEffect(() => {
        if (type === "Product" && !priceSpiderProductKey) {
            return;
        }

        if (type === "Generic" && !priceSpiderGenericKey) {
            return;
        }

        const metaPsKey = document.createElement("meta");
        metaPsKey.name = "ps-key";

        if (type === "Product") {
            metaPsKey.content = `${priceSpiderProductKey}`;
        }

        if (type === "Generic") {
            metaPsKey.content = `${priceSpiderGenericKey}`;
        }

        const metaPsCountry = document.createElement("meta");
        metaPsCountry.name = "ps-country";
        metaPsCountry.content = "us";

        const metaPsLanguage = document.createElement("meta");
        metaPsLanguage.name = "ps-language";
        metaPsLanguage.content = "en";

        const script = document.createElement("script");
        script.src = "//cdn.pricespider.com/1/lib/ps-widget.js";
        script.async = true;

        document.head.appendChild(metaPsKey);
        document.head.appendChild(metaPsCountry);
        document.head.appendChild(metaPsLanguage);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(metaPsKey);
            document.head.removeChild(metaPsCountry);
            document.head.removeChild(metaPsLanguage);
            document.head.removeChild(script);
        };
    }, [priceSpiderGenericKey, priceSpiderProductKey]);

    return null;
};

export default connect(mapStateToProps)(PriceSpider);
